const customerUpdateMeQuery = require('../../queries/user/customerUpdateMeQuery');
const { clientMutate } = require('../queries');
const handleCtApiError = require('../handleCtApiError');

/**
 * @param {Context} context
 * @param {Customer} currentUser
 * @param {Maybe<CustomQuery>} customQuery
 */
const deleteBillingAddress = async (context, currentUser, address) => {
  const actions = [];

  // Step 1: If the address is marked as billing, remove it
  if (currentUser.billingAddressIds?.includes(address.id)) {
    actions.push({
      removeBillingAddressId: { id: address.id },
    });
  }

  // Step 2: If it's the default billing address, unset it
  if (currentUser.defaultBillingAddressId === address.id) {
    actions.push({
      setDefaultBillingAddress: { addressId: null },
    });
  }

  // Step 3: Remove the address itself
  actions.push({
    removeAddress: {
      addressId: address.id,
    },
  });

  // Step 4: Call the commercetools API
  const options = {
    mutation: customerUpdateMeQuery,
    variables: {
      version: currentUser.version,
      actions,
    },
    fetchPolicy: 'no-cache',
  };

  try {
    const updateResponse = await clientMutate(context, options);

    return updateResponse;
  } catch (error) {
    throw handleCtApiError(error);
  }
};

module.exports = deleteBillingAddress;
